<template>
  <div>
    <!-- 搜索表单 -->
    <el-form
      :model="table.where"
      class="ele-form-search ele-table-tool-default"
      size="small"
      @keyup.enter.native="$refs.table.reload()"
      @submit.native.prevent
    >
      <el-row :gutter="15">
        <el-col :md="12" :sm="12">
          <div class="ele-form-actions">
            <el-button @click="add" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加</el-button>
            <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small">删除 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 数据表格 -->
    <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 261px)" highlight-current-row>
      <el-table-column type="selection" width="45" align="center" fixed="left" />
      <el-table-column prop="teacherName" label="姓名" sortable="custom" min-width="100px" show-overflow-tooltip />
      <el-table-column prop="mobile" label="手机号" sortable="custom" show-overflow-tooltip min-width="110">
        <template #default="{ row }">{{ row.mobile | phoneSafe }}</template>
      </el-table-column>
      <el-table-column label="操作" width="210px" align="center" :resizable="false">
        <template #default="{ row }">
          <el-popconfirm title="确定要删除此用户吗？" @onConfirm="remove(row)" class="ele-action">
            <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </ele-data-table>
    <!-- 添加人员 -->
    <el-dialog title="添加人员" :visible.sync="showgroupTeacher" width="400px" :destroy-on-close="true" :lock-scroll="false">
      <el-scrollbar style="height: 60vh" wrapStyle="overflow-x: hidden;">
        <el-card style="box-shadow: none">
          <el-row :gutter="15">
            <el-col :md="24" style="margin-bottom: 10px">
              <div class="org-tree-group">
                <el-tree
                  ref="teacherTree"
                  :data="teacherCheckData"
                  :check-strictly="true"
                  :props="{ label: 'name' }"
                  :expand-on-click-node="false"
                  node-key="id"
                  :default-expand-all="true"
                  :default-checked-keys="teacherChecked"
                  highlight-current
                  show-checkbox
                />
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-scrollbar>
      <div slot="footer">
        <el-button @click="showgroupTeacher = false">取消</el-button>
        <el-button type="primary" @click="savegroupTeacher">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { deleteGroupTeacher, getGroupTeacherChecked, groupUpdateTeacher } from '@/config/api';

  export default {
    name: 'TeacherList',
    props: {
      id: Number,
    },
    data() {
      return {
        table: {
          // 表格配置
          url: '/group/getGroupTeacherList',
          method: 'GET',
          where: { id: this.id },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        showgroupTeacher: false, // 显示添加人员
        teacherCheckData: [],
        choose: [],
      };
    },
    computed: {
      // 获取选中数据
      teacherChecked() {
        let teacherChecked = [];
        this.$util.eachTreeData(this.teacherCheckData, (d) => {
          if (d.checked && (!d.children || !d.children.length)) teacherChecked.push(d.id);
        });
        return teacherChecked;
      },
    },
    watch: {
      /* 监听机构id变化 */
      id() {
        this.table.where.id = this.id;
        this.$refs.table.reload();
      },
    },
    mounted() {},
    methods: {
      /* 显示添加 */
      add() {
        this.showgroupTeacher = true;
        this.teacherCheckData = [];
        const loading = this.$loading({ lock: true });
        let data = {
          id: this.id,
        };
        // 获取工作老师选中状态
        getGroupTeacherChecked(data)
          .then((res) => {
            if (res.data.resCode == 200) {
              loading.close();
              this.nodeNoChecked(res.data.data);
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            loading.close();
            this.$message.error(e.message);
          });
      },
      //循环数组
      nodeNoChecked(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type === 1) {
            data[i].disabled = true;
          }
          if (data[i].children) {
            this.nodeNoChecked(data[i].children);
          }
        }
        this.teacherCheckData = data;
      },
      /* 删除 */
      remove(row) {
        if (!row) {
          // 批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          let ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的用户吗?', '提示', { type: 'warning' })
            .then(() => {
              const loading = this.$loading({ lock: true });
              let formData = new FormData();
              formData.append('groupId', this.id);
              formData.append('ids', ids);
              deleteGroupTeacher(formData)
                .then((res) => {
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            })
            .catch(() => 0);
        } else {
          // 单个删除
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('groupId', this.id);
          formData.append('ids', row.id);
          deleteGroupTeacher(formData)
            .then((res) => {
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        }
      },
      // 保存分配的老师
      savegroupTeacher() {
        const loading = this.$loading({ lock: true });
        let teacherIds = this.$refs.teacherTree.getCheckedKeys().concat(this.$refs.teacherTree.getHalfCheckedKeys());
        let data = new FormData();
        data.append('teacherIds', teacherIds);
        data.append('id', this.id);
        groupUpdateTeacher(data)
          .then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showgroupTeacher = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          })
          .catch((e) => {
            loading.close();
            this.$message.error(e.message);
          });
      },
    },
  };
</script>

<style scoped></style>
